import { render } from "./SecretSocietyDissolve.vue?vue&type=template&id=47c22542"
import script from "./SecretSocietyDissolve.vue?vue&type=script&lang=js"
export * from "./SecretSocietyDissolve.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/embassy/windowOverlay/SecretSocietyDissolve.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47c22542"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47c22542', __exports__)) {
    api.reload('47c22542', __exports__)
  }
  
  module.hot.accept("./SecretSocietyDissolve.vue?vue&type=template&id=47c22542", () => {
    api.rerender('47c22542', render)
  })

}


export default __exports__